/* eslint-disable react/button-has-type */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Title } from '../../styles/GlobalStyles';
import notFoundImage from '../../assets/img/404.png'; // Substitua pelo caminho da sua imagem

export default function Page404() {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <Container style={{ textAlign: 'center', padding: '50px' }}>
      <img
        src={notFoundImage}
        alt="Página não encontrada"
        style={{ maxWidth: '100%', height: 'auto', marginBottom: '20px' }}
      />
      <Title style={{ fontSize: '2rem', marginBottom: '20px' }}>
        Ops! Essa página não existe.
      </Title>
      <p style={{ fontSize: '1rem', color: '#555', marginBottom: '30px' }}>
        Parece que você tentou acessar uma página que não está disponível. Vamos
        voltar para a página inicial?
      </p>
      <button
        onClick={handleBackToHome}
        style={{
          padding: '10px 20px',
          fontSize: '1rem',
          backgroundColor: '#007BFF',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
        Voltar para a Página Inicial
      </button>
    </Container>
  );
}
